import { useState, useEffect } from 'react';
import { TALENT_ARR } from '../../data/define';
import ReactApexChart from 'react-apexcharts';
import ImgKidFace from '../../assets/image/img_kidface.png';
import ToolTip from '../common/ToolTip';
import IntelligenceRankLabel from '../common/IntelligenceRankLabel';
import { useTranslation } from '../../hook/useTranslation';

// import EmptyCase from '../common/EmptyCase';

const Height = 150;
const Width = 150;

function ReportSummary({ result = [] }: { result?: any[] }) {
  const { t } = useTranslation();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [seriesHigh, setSeriesHigh] = useState({ id: 1, value: [0] });
  const [seriesLow, setSeriesLow] = useState({ id: 1, value: [0] });
  // const [emptyOpen, setEmptyOpen] = useState(false);

  useEffect(() => {
    if (result && result.length > 0) {
      const valid = result.filter((el) => el.score != null);
      if (valid.length > 0) {
        const maxElement = valid.reduce((prev, curr) => (prev.score > curr.score ? prev : curr));
        setSeriesHigh({ id: maxElement.id, value: [maxElement.score] });
        const minElement = valid.reduce((prev, curr) => (prev.score < curr.score ? prev : curr));
        setSeriesLow({ id: minElement.id, value: [minElement.score] });
      }
    }
  }, [result]);

  // emptyCase set
  // useEffect(() => {
  //   const hasData = result?.filter(
  //     (item) => item.score !== undefined && item.score !== null
  //   )?.length;
  //   if (hasData < 4) {
  //     setEmptyOpen(true);
  //   } else {
  //     setEmptyOpen(false);
  //   }
  // }, [result]);

  const options = {
    chart: {
      height: Height,
      type: 'radialBar',
    },
    colors: ['#74DFE0'],
    stroke: {
      lineCap: 'round',
      width: 12,
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: '45%',
        },
        track: {
          show: true,
          background: '#F8F8F8',
          strokeWidth: '100%',
        },
        dataLabels: {
          enabled: false,
          name: {
            show: false,
          },
          value: {
            show: false,
          },
        },
      },
    },
  };

  const IntelligenceHigh = TALENT_ARR.find((tlt) => tlt.id === seriesHigh?.id);
  const IntelligenceLow = TALENT_ARR.find((tlt) => tlt.id === seriesLow?.id);

  return (
    <div className="w-full relative pt-[20px] pb-[20px]">
      <div className="flex items-center justify-start gap-2 mb-[20px]">
        <div className="text-[#1C1C1C] font-[700] text-[20px] text-left]">{t('report.summary.title')}</div>
        <ToolTip
          open={tooltipOpen}
          setOpen={setTooltipOpen}
          text={t('report.summary.tooltip')}
        />
      </div>
      <div className="w-full flex items-center justify-between">
        <div
          className="grow h-[230px] rounded-[10px] bg-white flex flex-col items-center justify-center"
          style={{ boxShadow: '0px 0px 10px 0px rgba(29, 32, 32, 0.07)' }}
        >
          <div className="font-[400] text-[14px] text-[#767676]">{t('history.video.intelligence_title', { label: t(`talent.${IntelligenceHigh?.key}`) })}</div>
          <div className="font-[700] text-[20px] text-[#767676] mb-[-20px]">
            {t('report.summary.score', { score: seriesHigh?.value[0] })}
          </div>
          <div className="relative">
            <ReactApexChart
              options={options as any}
              series={seriesHigh?.value}
              type="radialBar"
              height={Height}
              width={Width}
            />
            <img
              src={ImgKidFace}
              alt="thumnail1"
              className="w-[30px] h-[30px] absolute top-[50%] left-[50%] translate-y-[-25%] translate-x-[-50%]"
            />
          </div>
          <IntelligenceRankLabel rank={1} />
        </div>
        {result?.length > 1 && (
          <div
            className="grow h-[230px] rounded-[10px] bg-white flex flex-col items-center justify-center"
            style={{ boxShadow: '0px 0px 10px 0px rgba(29, 32, 32, 0.07)' }}
          >
            <div className="font-[400] text-[14px] text-[#767676]">{t('history.video.intelligence_title', { label: t(`talent.${IntelligenceLow?.key}`) })}</div>
            <div className="font-[700] text-[20px] text-[#767676] mb-[-20px]">
            {t('report.summary.score', { score: seriesLow?.value[0] })}
            </div>
            <div className="relative">
              <ReactApexChart
                options={options as any}
                series={seriesLow?.value}
                type="radialBar"
                height={Height}
                width={Width}
              />
              <img
                src={ImgKidFace}
                alt="thumnail1"
                className="w-[30px] h-[30px] absolute top-[50%] left-[50%] translate-y-[-25%] translate-x-[-50%]"
              />
            </div>
            <IntelligenceRankLabel rank={3} />
          </div>
        )}
      </div>
      <div className="bg-[#F8F8F8] p-[20px] rounded-xl text-[#363636] text-[14px] font-[400] mt-[20px] break-keep">
        {t('report.summary.desc_high', { label: t(`talent.${IntelligenceHigh?.key}`) })} <span className="font-[600]">{t('report.summary.score', { score: seriesHigh?.value[0] })}</span>
        <br />
        {t('report.summary.desc_low', { label: t(`talent.${IntelligenceLow?.key}`) })} <span className="font-[600]">{t('report.summary.score', { score: seriesLow?.value[0] })}</span>
      </div>
      {/* <EmptyCase open={emptyOpen} text="리포트 요약" /> */}
    </div>
  );
}

export default ReportSummary;
